<template>
  <v-toolbar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    app
    fixed
    flat
    class="content-toolbar"
  >
    <!-- left toolbar -->

    <article class="toolbar-left">
      <v-toolbar-title class="content-left-toolbar">
        <!-- <router-link style='cursor:pointer;' class="subheading hidden-sm-and-down white--text" tag="span" :to="{ name: 'adminpage-cockpit' }">
          
          Jano

        </router-link>-->

        <router-link class="logo-default" :to="{ name: 'adminpage-cockpit' }">
          <img width="180" :src="T('./static/logo/logo.svg')" />
        </router-link>
      </v-toolbar-title>
    </article>

    <!-- end left -->

    <!-- center toolbar -->

    <article class="toolbar-center" style="justify-content: space-between">
      <div class="content-burger-menu">
        <a
          href="javascript:;"
          class="burger-menu"
          @click.stop="menudata.drawer = !menudata.drawer"
        >
          <span></span>
        </a>
      </div>

      <!-- <v-toolbar-side-icon @click.stop="menudata.drawer = !menudata.drawer"></v-toolbar-side-icon> -->

      <!-- search content -->

      <div class="srh-toolbar">
        <top-search :menudata="menudata"></top-search>
      </div>
    </article>

    <!-- end center -->

    <!-- right -->

    <article class="toolbar-right">
      <section class="content-right-toolbar">
        <ul class="list-icon-toolbar">
          <li class="item-icon-toolbar" v-if="devmode">
            <el-tooltip
              class="item"
              effect="dark"
              :content="T('Executar Builder')"
              placement="bottom"
            >
              <span class="ball-icon-toolbar">
                <v-btn icon class="icon-toolbar" @click="builderRun()">
                  <v-icon>layers</v-icon>
                </v-btn>
              </span>
            </el-tooltip>
          </li>

          <li class="item-icon-toolbar">
            <el-tooltip
              class="item"
              effect="dark"
              :content="T('Notificações')"
              placement="bottom"
            >
              <span class="ball-icon-toolbar">
                <v-btn icon class="icon-toolbar">
                  <v-icon>notifications</v-icon>
                </v-btn>
              </span>
            </el-tooltip>
          </li>

          <v-spacer></v-spacer>

          <v-menu
            open-on-hover
            top
            offset-y
            v-if="languages != null && this.loading == false && profile != null"
          >
            <v-btn
              icon
              class="white--text"
              small
              slot="activator"
              dark
              @click.ctrl.stop="setLangDebug()"
            >
              {{ profile.language || langactive }}&nbsp;
              <v-icon>language</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile
                v-for="(item, index) in languages"
                :key="index"
                @click="setLang(item)"
              >
                <v-list-tile-title
                  @click.ctrl.stop="setLangDebug()"
                  @click.shift.stop="getLangDebug(item)"
                  @click.alt.stop="getLangDebug(item, 'server')"
                  >{{ item }}</v-list-tile-title
                >
              </v-list-tile>
            </v-list>
          </v-menu>
        </ul>

        <!--  -->

        <div class="user-toolbar">
          <div class="user-toolbar-text">
            <p class="subt-toolbar">{{ T("Bem Vindo!") }}</p>

            <h3 class="user-name-toolbar">{{ features.userinfo.nome }}</h3>
          </div>

          <el-dropdown class="drop-default-toolbar">
            <div class="content-user-toolbar">
              <div
                Dropdown
                class="el-dropdown-link user-toolbar-avatar no-image"
              >
                <!-- class add when have image { with-image } -->

                <v-icon class="icon-no-user">perm_identity</v-icon>
                <!-- when no have a user image -->

                <!-- <v-img src="../../static/img/woman2.jpg" class="image-toolbar-avatar" /> -->
                <!-- when have a user image -->
              </div>

              <v-icon class="icon-arrow-user-toolbar"
                >keyboard_arrow_down</v-icon
              >
            </div>

            <el-dropdown-menu slot="dropdown" class="drop-default">
              <el-dropdown-item>
                <div class="item-menu-drop">
                  <!-- <i aria-hidden="true" class="v-icon mdi mdi-clock-outline icon-menu-drop"></i> -->

                  <v-flex class="text-menu-drop">
                    <a
                      :href="
                        '#/admin/app/' +
                        global.config.pessoa +
                        '/action/edit/' +
                        features.userinfo.id
                      "
                      >{{ T("Meus Dados") }}</a
                    >
                  </v-flex>
                </div>
              </el-dropdown-item>

              <!-- change pass -->

              <el-dropdown-item>
                <div class="item-menu-drop">
                  <!-- <i aria-hidden="true" class="v-icon mdi mdi-clock-outline icon-menu-drop"></i> -->

                  <v-flex @click="changePassword()" class="text-menu-drop">{{
                    T("Alterar senha")
                  }}</v-flex>
                </div>

                <!-- modal change password -->

                <div class="dialog-default">
                  <v-dialog v-model="dialogPass" persistent max-width="380px">
                    <v-card>
                      <div class="dialog-title-default">
                        <p>{{ T("Alterar Senha") }}</p>

                        <h3>{{ T("Nova Senha") }}</h3>
                      </div>

                      <v-alert
                        v-if="pass.passMsg != null"
                        :value="true"
                        color="red white--text"
                        icon="warning"
                        transition="scale-transition"
                        >{{ T(pass.passMsg) }}</v-alert
                      >

                      <div class="dialog-body-default">
                        <v-card-text>
                          <v-text-field
                            :label="T('Senha atual')"
                            v-model="pass.old"
                            type="password"
                            required
                          ></v-text-field>

                          <v-text-field
                            :label="T('Nova senha')"
                            v-model="pass.new"
                            type="password"
                            required
                          ></v-text-field>

                          <v-text-field
                            :label="T('Repita a senha')"
                            v-model="pass.new2"
                            type="password"
                            required
                          ></v-text-field>
                        </v-card-text>
                      </div>

                      <div class="dialog-footer-default">
                        <v-card-actions class="dialog-footer-btns">
                          <v-btn
                            color="grey"
                            flat
                            @click="dialogPass = false"
                            >{{ T("Cancelar") }}</v-btn
                          >

                          <v-btn color="primary" @click="changePasswordDo()">{{
                            T("Alterar")
                          }}</v-btn>
                        </v-card-actions>
                      </div>
                    </v-card>
                  </v-dialog>
                </div>
              </el-dropdown-item>

              <el-dropdown-item>
                <div class="item-menu-drop">
                  <!-- <i aria-hidden="true" class="v-icon mdi mdi-clock-outline icon-menu-drop"></i> -->

                  <v-flex @click="logout()" class="text-menu-drop">{{
                    T("Sair")
                  }}</v-flex>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </section>
    </article>
  </v-toolbar>
</template>

<script>
const Api = global.Api;
const TopSearch = global.reqClass.requirecmpmix(
  "@/admin/elements/inc/topsearch"
);

export default {
  data: () => ({
    devmode: global.config.devmode,
    features: global.features,
    global: global,
    loading: false,
    search: null,
    select: "",
    itemsauto: [],
    debounce: null,
    querymodules: null,
    queryicons: {},
    languages: null,
    langactive: "",

    dialogPass: false,
    pass: {
      old: "",
      new: "",
      new2: "",
      passMsg: null,
    },
  }),
  props: ["menudata", "profile"],
  mounted() {
    if (
      global.config.metadmin != null &&
      global.config.metadmin.multilang != null
    ) {
      this.languages = global.config.metadmin.multilang.langs;
      this.langactive = global.config.metadmin.multilang.def;
    }
  },
  methods: {
    builderRun() {
      if (
        window.confirm(
          "Confirma a execução da sincronização de estrutura de módulos e banco de dados?"
        )
      ) {
        window.open(global.config.endpoint + "/admin/metadmin/builder/gen");
      }
    },
    logout() {
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);

      window.document.body.innerHTML = "";
      window.location = window.location.href.split("#")[0];
      /*this.$router.replace({
        name: "admin-login"
      });*/
    },

    setLangDebug() {
      global.lang_debug_mode = !global.lang_debug_mode;
    },
    async setLang(lang) {
      await global.fn.meta_set_active_lang(lang, this);
    },

    getLangDebug(lang, server = null) {
      return global.fn.meta_get_lista_lang_pendente(lang, this, server);
    },

    changePassword() {
      this.dialogPass = !this.dialogPass;
      this.pass.passMsg = null;
      this.pass.old = this.pass.new = this.pass.new2 = "";
    },

    async changePasswordDo() {
      let msg = "";
      if (!this.pass.old || !this.pass.new || !this.pass.new2) {
        msg = "Todos os campos devem ser preenchidos!";
      } else if (this.pass.new != this.pass.new2) {
        msg = "As senhas não conferem!";
      } else if (
        (this.pass.new || this.pass.new2) &&
        this.pass.new.length < 4
      ) {
        msg = "As senhas devem possuir no mínimo 4 caracteres!";
      }

      if (msg != "") {
        this.pass.passMsg = msg;
        return;
      }

      this.loading = true;
      try {
        let resp = await global.express.call(
          "/action/metadmin/setpass",
          "post",
          null,
          this.pass
        );

        let toast = this.$toasted.show("Senha alterada com sucesso!", {
          theme: "outline",
          position: "top-center",
          duration: 5000,
        });
        this.dialogPass = false;
      } catch (e) {
        if (e.response != null) {
          //erro disparado back-end
          this.pass.passMsg = e.response.data.error;
        } else if (!!e.message) {
          //erro disparado front-end
          this.pass.passMsg = e.message;
        }
      }
      this.loading = false;
    },
  },
  components: {
    TopSearch,
  },
  watch: {
    "menudata.drawer": {
      handler(old, newv) {
        setTimeout(() => {
          let ve = document.getElementsByClassName("v-overlay--active");
          for (let v of ve) {
            v.remove();
          }
        }, 500);
      },
    },
  },
};
</script>

<style scoped>
/* .home {
  cursor: pointer;
}
.home:hover {
  color: #e9e;
} */
</style>
